const swea = require('swea');
const InstructionServiceActions = swea.react.actions.InstructionServiceActions;

class CustomSpecifyTransformInteraction extends swea.editor.interactions.SpecifyTransformInteraction {
  /**
   * Constructs the interaction.
   * @param { object } options An option object, see below and SpecifyTransformInteraction for more info.
   * @param { string } options.instruction The general instruction string as specified in locale, e.g. 'instructions.zup'.
   * @param { string } options.invalidInstruction The invalid instruction string as specified in locale, e.g. 'instructions.invalid_specified_transform'.
   * @public
   */
  constructor(options = {}) {
    super(options);
    this._disabledInteractionClasses = [];
  }
  
  /**
   * Initializes the interaction.
   * @param element the element that the interaction listens to.
   * @param viewerId the viewer id of the viewer the interaction operates in.
   */
  initialize(element, viewerId){
    super.initialize(element, viewerId);

    // Close tool with Escape
    this.addTrigger(new swea.editor.interactions.EventHandler(
      [swea.editor.interactions.eventCodes.ESC],
      this,
      () => {
        this.terminate();
      }
    ));
    
    // Remove last point with Backspace
    this.addTrigger(new swea.editor.interactions.EventHandler(
      [swea.editor.interactions.eventCodes.BACK_SPACE],
      this,
      () => {
        this.removeLastPoint();
      }
    ));
  }

  whenInitialized(element, viewerId){
    element;
    viewerId;
    this._disabledInteractionClasses = swea.editor.InteractionManager.instance().disableContinuousInteractions();
    InstructionServiceActions.showInstruction(this._options.instruction);
  }

  whenTerminated(element, viewerId) {
    super.whenTerminated(element, viewerId);
    swea.editor.InteractionManager.instance().enableContinuousInteractions(this._disabledInteractionClasses);
    InstructionServiceActions.hideInstruction();
  }
  
  /**
   * Called when finishing a z-up line that doesn't have exactly two points.
   * @private
   * @override
   */
  _whenNotTwoPoints() {
    InstructionServiceActions.showInstruction(this._options.invalidInstruction);
  }
}
export default CustomSpecifyTransformInteraction;
